import Vue from 'vue/dist/vue.esm'
import template from './date_range_filter_template.slim'
import flatpickr from 'flatpickr'

function parseIsoDate(value) {
  const [year, month, day] = value.split('-').map(Number)
  return new Date(year, month - 1, day)
}

function toIsoDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

Vue.component('date-range-filter', {
  mixins: [template],
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  watch: {
    value(newValue) {
      if (!this.flatpickr || this.matchesSelection(newValue)) return

      if (newValue) {
        this.flatpickr.setDate([parseIsoDate(newValue.startDate), parseIsoDate(newValue.endDate)], false)
      } else {
        this.flatpickr.clear(false)
      }
    }
  },
  mounted() {
    const currentYear = new Date().getFullYear()
    const minDate = new Date(2000, 0, 1)
    const maxDate = new Date(currentYear + 10, 11, 31)
    this.minYear = minDate.getFullYear()
    this.maxYear = maxDate.getFullYear()

    this.flatpickr = flatpickr(this.$refs.input, {
      mode: 'range',
      dateFormat: 'm/d/Y',
      minDate,
      maxDate,
      shorthandCurrentMonth: true,
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        }
      },
      clickOpens: false,
      positionElement: this.$refs.badge,
      ignoredFocusElements: [this.$refs.badge],
      defaultDate: this.value ? [parseIsoDate(this.value.startDate), parseIsoDate(this.value.endDate)] : [],
      onReady: this.onReady,
      onChange: this.onChange,
      onMonthChange: this.onMonthChange
    })
  },
  beforeDestroy() {
    if (this.flatpickr) this.flatpickr.destroy()
  },
  methods: {
    onReady(selectedDates, dateStr, instance) {
      instance.calendarContainer.classList.add('bullseye-calendar', 'district-date-range-calendar')
      this.createYearDropdown(instance)
    },
    createYearDropdown(instance) {
      const yearInput = instance.calendarContainer.querySelector('.numInput.cur-year')
      if (!yearInput) return

      const select = document.createElement('select')
      select.className = 'flatpickr-yearDropdown'
      for (let year = this.minYear; year <= this.maxYear; year += 1) {
        const option = document.createElement('option')
        option.value = year
        option.textContent = year
        if (year === instance.currentYear) option.selected = true
        select.appendChild(option)
      }
      select.addEventListener('change', () => instance.changeYear(parseInt(select.value, 10)))
      yearInput.replaceWith(select)
      instance.calendarContainer.querySelectorAll('.arrowUp, .arrowDown').forEach((arrow) => { arrow.style.display = 'none' })
    },
    onMonthChange(selectedDates, dateStr, instance) {
      const yearDropdown = instance.calendarContainer.querySelector('.flatpickr-yearDropdown')
      if (yearDropdown) yearDropdown.value = instance.currentYear
    },
    toggle() {
      if (this.flatpickr.isOpen) {
        if (this.flatpickr.selectedDates.length === 1) this.flatpickr.clear()
        this.flatpickr.close()
      } else {
        this.flatpickr.open()
      }
    },
    onChange(selectedDates) {
      if (selectedDates.length !== 2) return

      const [startDate, endDate] = selectedDates
      this.$emit('change', { startDate: toIsoDate(startDate), endDate: toIsoDate(endDate) })
    },
    matchesSelection(range) {
      const selectedDates = this.flatpickr.selectedDates
      if (!range) return selectedDates.length === 0

      return selectedDates.length === 2 &&
        toIsoDate(selectedDates[0]) === range.startDate &&
        toIsoDate(selectedDates[1]) === range.endDate
    },
    clear() {
      this.flatpickr.clear(false)
    }
  }
})
